import React from "react";
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import AdminDashboard from "../pages/admin/dashboard/page";
import PurchaserDashboard from "../pages/purchaser/dashboard/page";
import AgentDashboard from "../pages/agent/dashboard/page";
import BidderDashboard from "../pages/bidder/dashboard/page";
import ExpertDashboard from "../pages/expert/dashboard/page";
import SupervisorDashboard from "../pages/supervisor/dashboard/page";
import DocumentEditor from "../pages/agent/document-editor/page";
import KnowledgeBase from "../pages/agent/knowledge-base/page";
import RiskCheck from "../pages/agent/risk-check/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/admin/dashboard",
    element: <AdminDashboard />,
  },
  {
    path: "/purchaser/dashboard",
    element: <PurchaserDashboard />,
  },
  {
    path: "/agent/dashboard",
    element: <AgentDashboard />,
  },
  {
    path: "/agent/document-editor",
    element: <DocumentEditor />,
  },
  {
    path: "/agent/knowledge-base",
    element: <KnowledgeBase />,
  },
  {
    path: "/agent/risk-check",
    element: <RiskCheck />,
  },
  {
    path: "/bidder/dashboard",
    element: <BidderDashboard />,
  },
  {
    path: "/expert/dashboard",
    element: <ExpertDashboard />,
  },
  {
    path: "/supervisor/dashboard",
    element: <SupervisorDashboard />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
